<template>
  <div class="wrap">
		<select name="location" id="location" class="select-el" v-model="selected" @change="$emit('change', selectedPermission.parent_code + '_' + selected)">
			<option value="" selected disabled>Select location</option>
			<option :value="el.loc_name" v-for="(el, i) in getDropdownElements" :key="i">
				{{el.loc_id + ' - ' + el.loc_name}}
			</option>
		</select>
  </div>
</template>

<script>
import api from '@/api'
const PermType = {
    booth: "booth_enter",
    conf: "conf_enter",
    expo: "expo_enter",
    expo_v: "expo_view",
    conf_v: "conf_view",
    poll_v: "poll_view",
		
}
const LocType = {
	booth: "bth",
	conf: "conf",
	expo: "intl",
	expo_v: "intl",
	conf_v: "conf",
    poll_v: "poll"
}

export default {
    data() {
        return {
            allLocations: [],
            selected: '',
        }
    },
    watch: {
        selectedPermission: {
            deep: true,
            handler() {
                this.selected = ''
            }
        }
    },
    computed: {
        getLocType () {
            if (this.selectedPermission.parent_code === PermType.booth) return LocType.booth
            if (this.selectedPermission.parent_code === PermType.conf) return LocType.conf
            if (this.selectedPermission.parent_code === PermType.expo) return LocType.expo
            if (this.selectedPermission.parent_code === PermType.expo_v) return LocType.expo_v
            if (this.selectedPermission.parent_code === PermType.conf_v) return LocType.conf_v
            if (this.selectedPermission.parent_code === PermType.poll_v) return LocType.poll_v
            return ''
        },
        getDropdownElements () {
            if (this.getLocType === '') return []
            return this.allLocations.filter(el => el.ltp_code === this.getLocType)
        }
    },
    props: {
        selectedPermission: Object,
    },
    mounted() {
        this.init()
    },
    methods: {
        async init () {
            try {
                let res = await api.getAgendaLocations();
                this.allLocations = res.data.result.filter(el => el.loc_name)
                await this.addPolls()
            } catch (error) {
                console.warn(error);
            }
                
        },
        async addPolls() {
            try {
                let res = await api.getAllPolls();     
                let polls = res.data.data.map(el => {
                    return {
                        // small hack so i do not have to refactor whole comp
                        loc_id: el.pls_name,
                        loc_name: el.pls_id,
                        ltp_code: LocType.poll_v
                    }
                });
                this.allLocations = [...this.allLocations, ...polls]
            } catch (error) {
                console.warn(error);
            }
        }
    },
}
</script>

<style scoped lang='scss'>
	.wrap {
		width: 150px;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		.select-el {
			width: 100%;
		}
	}
</style>